import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WPublicWeddingView } from '@zola/svc-web-api-ts-client';

export const getWeddingBySlug = async (slug: string): Promise<WPublicWeddingView> =>
  ApiService.get<WPublicWeddingView>(`/web-api/v1/publicwedding/slug/${slug}`);
